import { createElement, type KeyboardEvent } from 'react';

export interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  'aria-label': string;
  autoFocus?: boolean;
  id?: string;
  name?: string;
  className?: string;
}

export function SearchInput({
  value,
  onChange,
  placeholder,
  'aria-label': ariaLabel,
  autoFocus,
  id,
  name,
  className,
}: SearchInputProps) {
  function onKeyDown(event: KeyboardEvent<HTMLInputElement>) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
    if (event.key === 'Escape') {
      event.preventDefault();
      onChange('');
    }
  }

  return createElement(
    'div',
    { className: `lms-search-input relative w-full ${className ?? ''}`.trim() },
    createElement(
      'span',
      {
        className: 'lms-search-input__icon material-symbols-outlined text-dash-outline',
        'aria-hidden': 'true',
      },
      'search',
    ),
    createElement('input', {
      id,
      name,
      type: 'search',
      value,
      autoFocus,
      placeholder,
      'aria-label': ariaLabel,
      onChange: (event: { target: { value: string } }) => onChange(event.target.value),
      onKeyDown,
      className:
        'h-11 w-full rounded-xl border border-dash-outline-variant bg-white py-2 pl-10 pr-10 text-sm text-dash-on-surface shadow-sm outline-none placeholder:text-dash-outline focus:border-transparent focus:ring-2 focus:ring-dash-primary [&::-webkit-search-cancel-button]:hidden [&::-webkit-search-decoration]:hidden',
    }),
    value
      ? createElement(
          'button',
          {
            type: 'button',
            className:
              'absolute right-2 top-1/2 flex h-7 w-7 -translate-y-1/2 items-center justify-center rounded-md text-sm text-dash-on-surface-variant hover:bg-secondary-100',
            'aria-label': 'Borrar texto de búsqueda',
            onClick: () => onChange(''),
          },
          '✕',
        )
      : null,
  );
}
